import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { authReducer } from '../redux/auth/authReducer';
import { userReducer } from '../components/Dashboard/User/UserReducer';
import { locationReducer } from '../redux/location/locationReducer';
import { spaceReducer } from '../components/Dashboard/Spaces/SpaceReducer';
import { activityReducer } from './Activity/activityReducer';
import { newsLetterReducer } from '../components/Dashboard/NewsLetter/NewsLetterReducer';
import { assignSpaceReducer } from '../components/Dashboard/AssignSpace/AssignSpaceReducer';
import { createHostReducer } from '../components/Dashboard/CreateHost/CreateHostReducer';
import { newHostOnboardingReducer } from '../components/Dashboard/NewHostOnboarding/NewHostOnboardingReducer';
import { spaceReviewReducer } from '../components/Dashboard/SpaceReview/SpaceReviewReducer';
import uiStateReducer from './reducers/uistate';
import { promoCodeReducer } from '../components/Dashboard/promoCodeUsage/PromoCodeReducer';
import { createPromoCodeReducer } from '../components/Dashboard/CreatePromoCode/CreatePromoCodeReducer';
import { CreateAdminReducer } from '../components/Dashboard/CreateAdmin/CreateAdminReducer';
import { addSuperDealReducer } from '../components/Dashboard/SuperDeals/AddSuperDealReducer';
import { userReviewsReducer } from '../components/Dashboard/UserReviews/ListUserReviews/ListUserReviewsReducer';
import offlineBookingReducer from '../components/Dashboard/OfflineBooking/OfflineBookingReducer';
import { auditLogReducer } from './auditLog/auditLogReducer';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    user: userReducer,
    location: locationReducer,
    space: spaceReducer,
    spaceReview: spaceReviewReducer,
    activity: activityReducer,
    newsLetter: newsLetterReducer,
    assignspace: assignSpaceReducer,
    createHost: createHostReducer,
    newHostOnboarding: newHostOnboardingReducer,
    uiState: uiStateReducer,
    promoCode: promoCodeReducer,
    createPromoCode: createPromoCodeReducer,
    assignAdmin: CreateAdminReducer,
    addSuperDeal: addSuperDealReducer,
    listUserReviews: userReviewsReducer,
    offlineBooking: offlineBookingReducer,
    auditLog: auditLogReducer
  });
